import { render, staticRenderFns } from "./game-baas.vue?vue&type=template&id=3c08120a"
import script from "./game-baas.vue?vue&type=script&lang=js"
export * from "./game-baas.vue?vue&type=script&lang=js"
import style0 from "./game-baas.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-baas.vue
// module id = X7Ao
// module chunks = 0